import dayjs from "dayjs"
import { routes } from "router"
import { numberFormat } from "helpers/string"
import { getDepartureCapacity, getMaxGuests } from "utils/experience"
import { LIST_DATE_PARAM_FORMAT, PRICE_SUFFIX_PRICING_TYPES } from "./constants"

// Cover image of a list experience: the photo at position 0 (same pick as the old widget's card).
export const getExperienceCoverImage = (experience) => {
  const photos = [
    ...(Array.isArray(experience?.photos) ? experience.photos : []),
    ...(Array.isArray(experience?.cropped_photos) ? experience.cropped_photos : [])
  ]
  return photos.find((photo) => photo?.position === 0)?.preview_url || photos[0]?.preview_url || null
}

// i18n key of the card's price suffix ("/ group", "/ person"), or null when the pricing type is unknown.
export const getPriceSuffixKey = (experience) => {
  const pricingType = experience?.experience_type === "ticketed" ? "charge_per_person" : experience?.pricing_type
  return PRICE_SUFFIX_PRICING_TYPES.includes(pricingType) ? `booking_widget.card.price_suffix.${pricingType}` : null
}

// Most guests one booking may hold. A ticketed booking is held to its max_tickets as well as the
// departure's places; whichever is known and smaller wins.
export const getGuestLimitPerBooking = (experience) => {
  if (experience?.experience_type !== "ticketed") return getMaxGuests(experience)
  const limits = [Number(experience?.max_tickets) || 0, getDepartureCapacity(experience)].filter(Boolean)
  return limits.length ? Math.min(...limits) : 0
}

// The list API's date parameter ("" for any date).
export const toListDateParam = (date) => (date ? dayjs(date).format(LIST_DATE_PARAM_FORMAT) : "")

// Ticket types a guest can buy: the enabled ones, in the order the API returns them.
export const getBookableTicketTypes = (experience) => (experience?.ticket_types || []).filter((ticketType) => ticketType?.enabled !== false)

// Where a #/widget/... URL lands in the old widget while NEW_BOOKING_WIDGET is off. The old widget
// has no cart or standalone checkout, so those fall back to the experience list.
export const getLegacyWidgetPath = ({ uuid, id }) =>
  id ? routes.embeddedExperienceDetail({ uuid, id }) : routes.embeddedExperienceListing({ uuid })

// Card prices as in the design: whole amounts without cents ("$40"), otherwise two decimals ("$40.50").
export const formatListPrice = (value) => {
  if (value == null || value === "") return "—"
  const amount = Number(value)
  const fractionDigits = Number.isInteger(amount) ? 0 : 2
  return numberFormat(value, { style: "currency", currency: "USD", minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits })
}
